// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2SFKi","image":"Header_image__2vZL4","name":"Header_name__18pse","info":"Header_info__2pg3B","infoRow":"Header_infoRow__7OzPv"};